import { AppointmentStatus } from './appointments';

export const APPOINTMENT_STATUS_FREE: AppointmentStatus = 'FREE';
export const APPOINTMENT_STATUS_LOCKED: AppointmentStatus = 'LOCKED';
